import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** The current progress value */
  currentValue: PropTypes.number.isRequired,
  /** The maximum value for the progress bar */
  maximumValue: PropTypes.number.isRequired,
  /** Additional CSS classes to apply to the progress bar wrapper */
  classList: PropTypes.string
};
function ProgressBar(_ref) {
  var currentValue = _ref.currentValue,
    maximumValue = _ref.maximumValue,
    _ref$classList = _ref.classList,
    classList = _ref$classList === void 0 ? '' : _ref$classList;
  var progressBarClasses = "progress-bar ".concat(classList);
  return /*#__PURE__*/React__default.createElement("div", {
    className: progressBarClasses,
    "data-testid": "progress-bar-wrapper"
  }, /*#__PURE__*/React__default.createElement("progress", {
    "aria-hidden": "true",
    "data-testid": "progress-bar",
    value: currentValue,
    max: maximumValue
  }));
}
ProgressBar.propTypes = propTypes;

export { ProgressBar as default };
//# sourceMappingURL=ProgressBar.js.map
